"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const config_1 = require("config");
const React = require("react");
const ConfigContext_1 = require("src/ts/contexts/ConfigContext");
const LoggerHelper_1 = require("src/ts/helpers/LoggerHelper");
const EnvironmentHelper_1 = require("../../helpers/EnvironmentHelper");
const Footer_1 = require("../common/Footer");
const Padder_1 = require("../common/Padder");
class DoView extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._downloadSkype = () => {
            LoggerHelper_1.logger.action({ name: 'download' });
            const downloadUrl = EnvironmentHelper_1.os === EnvironmentHelper_1.OperatingSystems.MacOS ? config_1.default.urls.app.downloadDesktop : config_1.default.urls.app.download;
            window.open(downloadUrl, '_blank');
        };
    }
    renderLogo() {
        return React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => React.createElement(react_1.Image, { src: `${configContext.basePath}/images/states/browser-to-mobile.svg`, className: 'logo', "aria-hidden": 'true' }));
    }
    renderTitle() {
        return React.createElement(react_1.Header, { as: 'h1', className: 'title' }, bew_localization_1.localizer.getString('hdr_launch_joining_conversation'));
    }
    renderControls() {
        return React.createElement(React.Fragment, null,
            React.createElement(react_1.Button, { key: 0, id: 'btnLaunch', primary: true, onClick: this.props.onLaunchClick }, bew_localization_1.localizer.getString('btn_launch_join')));
    }
    renderBody() {
        return React.createElement(React.Fragment, null,
            React.createElement(react_1.Text, { size: 'medium', className: 'body' }, bew_localization_1.localizer.getString('txt_launch_first_time_device')),
            React.createElement(react_1.Text, { size: 'medium' }, bew_localization_1.localizer.get('txt_launch_please_download', {
                download_skype: React.createElement("a", { href: 'javascript:void(0);', id: 'downloadMobileClient', onClick: this._downloadSkype, style: { textDecoration: 'none', color: '#0078d4' } }, bew_localization_1.localizer.getString('btn_launch_download_skype')),
            })));
    }
    render() {
        return React.createElement("div", { className: 'do doView' },
            React.createElement(Padder_1.Padder, null),
            React.createElement("div", { className: 'scrollable-y' },
                this.renderLogo(),
                this.renderTitle(),
                this.renderControls(),
                this.renderBody()),
            React.createElement(Padder_1.Padder, null),
            React.createElement(Footer_1.Footer, null));
    }
}
exports.DoView = DoView;
